module.exports = __webpack_public_path__ + "static/media/ag-products2.73afd9f0.jpg";